import EasingController from '../../../assets/js/controller/easing';

import { bindEvents, getRootOffsetBounds } from '../../../assets/js/helpers';

export default class LoaderPageCharacter {

	constructor(section, options = {}) {
		this.el = {
			section
		};

		this.defaults = {
			defaults: {
				shift: {
					x: 0.5, // screen width
					y: 1.5, // screen height
					z: 30 // pixels
				},
				randomness: {
					x: 0.2,
					y: 0.4,
					z: 0.2,
					t: 0.1
				}
			},
			horizontal: {
				base: {
					x: 0,
					y: 0,
					z: 30,
					scale: 0.6
				},
				offsetMultiplier: {
					x: 1.5,
					y: 1.1,
					z: 1,
					t: 1
				}
			},
			vertical: {
				base: {
					x: 0,
					y: 0,
					z: 30,
					scale: 0.6
				},
				offsetMultiplier: {
					x: 1.5,
					y: 1.1,
					z: 1,
					t: 1
				}
			},
			square: {
				base: {
					x: 0,
					y: 0,
					z: 100,
					scale: 0.7
				},
				offsetMultiplier: {
					x: 0.8,
					y: 1,
					z: 1.2,
					t: 1
				}
			},
			squareSmall: {
				base: {
					x: 0,
					y: 0,
					z: 0,
					scale: 0.7
				},
				offsetMultiplier: {
					x: 1.1,
					y: 1.1,
					z: 1,
					t: 1
				}
			},
		};

		this.options = Object.assign({}, this.defaults, options);

		// class variable groups

		this.bounds = {
			section: null
		};

		this.config = {
			aspectRatio: section.dataset.aspectRatio,
			base: {
				x: 0,
				y: 0,
				z: 0
			},
			multiplier: {
				x: 1,
				y: 1,
				z: 1,
				t: 1
			},
			impetus: {
				x: 0,	// clip's desire to go somewhere regardless of where it's supposed to end up
				y: 0,
				z: 0
			}
		};

		this.easing = {
			in: EasingController.ease(EasingController.curves.easeIn),
			out: EasingController.ease(EasingController.curves.easeOutJim)
		};

		this.states = {
			ratio: 0
		};

		// bind events to class scope
		this.events = bindEvents(this);

		// mosey
		this.init();
	}

	// initialize

	init() {
		this.measureResize();
		this.rebuild();
	}

	// update measurements

	measureResize() {
		this.bounds.section = getRootOffsetBounds(this.el.section);
	}

	// randomize offsets, set initial position

	rebuild() {
		const winWidth = window.innerWidth;
		const winHeight = window.innerHeight;
		const winXRatio = (this.bounds.section.left - winWidth / 2) / (winWidth / 2);

		let aspectRatio = '';

		let startXOffset = 0;
		let startYOffset = 0;
		let startZOffset = 0;

		let baseXOffset = 0;
		let baseYOffset = 0;
		let baseZOffset = 0;
		let baseScale = 1;

		let multiplierX = 0;
		let multiplierY = 0;
		let multiplierZ = 0;
		let multiplierT = 0;

		switch (this.config.aspectRatio) {
			case 'horizontal':
			aspectRatio = 'horizontal';
			break;

			case 'vertical':
			aspectRatio = 'vertical';
			break;

			case 'square':
			aspectRatio = 'square';
			break;

			case 'squareSmall':
			aspectRatio = 'squareSmall';
			break;

			default:
			aspectRatio = 'square';
			break;
		}

		baseXOffset = this.options[aspectRatio].base.x;
		baseYOffset = this.options[aspectRatio].base.y;
		baseZOffset = this.options[aspectRatio].base.z;
		baseScale = this.options[aspectRatio].base.scale;

		multiplierX = this.options[aspectRatio].offsetMultiplier.x * (1 + (1 - Math.random() * 2) * this.options.defaults.randomness.x);
		multiplierY = this.options[aspectRatio].offsetMultiplier.y * (1 + (1 - Math.random() * 2) * this.options.defaults.randomness.y);
		multiplierZ = this.options[aspectRatio].offsetMultiplier.z * (1 + (1 - Math.random() * 2) * this.options.defaults.randomness.z);
		multiplierT = this.options[aspectRatio].offsetMultiplier.t * (1 + Math.random() * this.options.defaults.randomness.t);

		startXOffset = winXRatio * this.options[aspectRatio].offsetMultiplier.x * this.options.defaults.shift.x * winWidth;
		startYOffset = this.options[aspectRatio].offsetMultiplier.y * this.options.defaults.shift.y * winHeight;
		startZOffset = this.options[aspectRatio].offsetMultiplier.z * this.options.defaults.shift.z + this.options[aspectRatio].base.z;

		this.config = {
			start: {
				x: startXOffset,
				y: startYOffset,
				z: startZOffset
			},
			base: {
				x: baseXOffset,
				y: baseYOffset,
				z: baseZOffset,
				scale: baseScale
			},
			multiplier: {
				x: multiplierX,
				y: multiplierY,
				z: multiplierZ,
				t: multiplierT
			}
		};

		this.updateProgress(0);
	}

	//

	updateProgress(ratio) {
		let easedRatio = (1 - this.easing.out(ratio / this.config.multiplier.t));
		const { scale } = this.config.base;

		let translateX = 0;
		let translateY = 0;
		let translateZ = 0;

		if (ratio <= 1) {
			translateX = this.config.base.x + this.config.start.x * this.config.multiplier.x * easedRatio;
			translateY = this.config.base.y + this.config.start.y * this.config.multiplier.y * easedRatio;
			translateZ = this.config.base.z + this.config.start.z * this.config.multiplier.z * easedRatio;
		} else {
			easedRatio = (1 - this.easing.in((ratio - 1) / this.config.multiplier.t));
			translateX = this.config.base.x + this.config.start.x * this.config.multiplier.x * (1 - easedRatio);
			translateZ = this.config.base.z + this.config.start.z * this.config.multiplier.z * (1 - easedRatio);
			translateY = this.config.base.y + (0 - window.innerHeight * 2) * this.config.multiplier.y * (1 - easedRatio);
		}

		const translateXRounded = Math.round(translateX * 100) / 100;
		const translateYRounded = Math.round(translateY * 100) / 100;
		const translateZRounded = Math.round(translateZ * 100) / 100;

		this.el.section.style.transform = `translateX(${translateXRounded}px) translateY(${translateYRounded}px) translateZ(${translateZRounded}px) scale(${scale})`;
	}

	//

	destroy() {

	}

}
